import React from "react";
import { pieLabelPoint, slicePercentLabel } from "../../../../utils/analyticsChartLabels";

/**
 * Etiqueta de sector para los pies del Panel de Estadísticas: sólo el porcentaje, a
 * `PIE_LABEL_OFFSET` px del borde para que no quede pegado al sector. Se pasa a `<Pie label>`
 * como función; Recharts la llama con la geometría del sector (`cx`, `cy`, `midAngle`,
 * `outerRadius`, `percent`, `fill`).
 */
export const renderPiePercentLabel = (props) => {
  const text = slicePercentLabel(props);
  if (!text) return null;
  const { x, y, textAnchor } = pieLabelPoint(props);
  return (
    <text
      className="recharts-pie-label-text"
      x={x}
      y={y}
      fill={props.fill}
      textAnchor={textAnchor}
      dominantBaseline="central"
      style={{ fontSize: 12, fontWeight: 500 }}
    >
      {text}
    </text>
  );
};
